// Exported methods to log BIMSearch application events in our log

import { currentUser } from "./IUsers";
import { postToServer } from "./CommonFunctions";

// log error method
// errorLocation - code location of error
// error - error string | use js excetion object toString() for unknown excetion
export async function logError(errorLocation, error) {
    var data = [errorLocation, error];
    var url = `/api/log/error`;

    logEvent(url, data);
}

export async function logCreateSchedule(bimSearch, properties, groups) {
    var url = `/api/log/createschedule`;
    var data = [];
    data.push(["Model Name", bimSearch.modelName]);
    data.push(["User", getUserId()]);
    if (bimSearch.selectedCategories != null)
        data.push(["Categories", bimSearch.selectedCategories.join()]);
    data.push(["Second Filter", bimSearch.selectedFilter]);
    data.push(["Properties", properties.join()]);
    data.push(["Grouped By", groups.join()]);

    logEvent(url, data);
}

export async function logSelectCategory(bimSearch) {
    var url = `/api/log/categoryselected`;
    var data = [];

    data.push(["Model Name", bimSearch.modelName]);
    data.push(["User", getUserId()]);

    if (bimSearch.selectedCategories != null)
        data.push(["Categories", bimSearch.selectedCategories.join()]);

    logEvent(url, data);
}

export async function logDownloadSchedule() {
    var url = `/api/log/scheduledownloaded`;
    var data = [];
    data.push(["User", getUserId()]);

    logEvent(url, data);
}

export async function logIButton() {
    var url = `/api/log/iButton`;
    var data = [];
    data.push(["User", getUserId()]);

    logEvent(url, data);
}

export async function logTemplate(template) {
    var url = `/api/log/template`;
    var data = [];
    data.push(["User", getUserId()]);
    data.push(["Template", template]);

    logEvent(url, data);
}

export async function logTableLineSelected() {
    var url = `/api/log/tableline`;
    var data = [];
    data.push(["User", getUserId()]);

    logEvent(url, data);
}

export async function logDoubleClick(category, type) {
    var url = `/api/log/doubleclick`;
    var data = [];
    data.push(["Category", category]);
    data.push(["Type", type]);
    data.push(["User", getUserId()]);

    logEvent(url, data);
}

export async function logClusterButton(onOff) {
    var url = `/api/log/clusterbutton`;
    var data = [];
    
    data.push(["User", getUserId()]);
    data.push(["OnOff", onOff]);

    logEvent(url, data);
}

export async function logRightClick(selectedItems) {
    var url = `/api/log/rightclick`;
    var data = [];
    data.push(["User", getUserId()]);
    data.push(["SelectedItems", selectedItems]);

    logEvent(url, data);
}

export async function logIntegrationIssue() {
    var url = `/api/log/integrationIssue`;
    var data = [];
    data.push(["User", getUserId()]);
    logEvent(url, data);
}

async function logEvent(url, data) {
    postToServer(url, data);
}

function getUserId() {
    var userId = "NA";
    if (currentUser != null && currentUser.userId != null)
        userId = currentUser.userId;
    else
        logError("FrontEnd.src.utils.builder.IAmecLog.logClusterButton", "Can't get user ID");

    return userId;
}
